export const EstateActionTypes = {
    SET_ESTATE : 'SET_ESTATE',
    SET_ESTATES:'SET_ESTATES',
    SET_PANELS:'SET_PANELS',
    SET_PANELS_UNFILTERED:'SET_PANELS_UNFILTERED',
    SET_UNASSIGNED_PANELS:'SET_UNASSIGNED_PANELS',
    INSTALLER_EMAIL_ALERTS_FOR_ALL_PANELS:'INSTALLER_EMAIL_ALERTS_FOR_ALL_PANELS',
    USER_EMAIL_ALERTS_FOR_ALL_PANELS:'USER_EMAIL_ALERTS_FOR_ALL_PANELS',
}